import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Redirect, useHistory } from 'react-router-dom'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import ContactInput from 'components/ContactInput'
import ErrorDialog from 'components/ErrorDialog'
import Panel from 'components/Panel'
import { useAccount } from 'hooks/useAccount'
import useAuth from 'lib/auth'

export default function AccountNewPage() {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm()
  const { createAccount } = useAccount()
  const { user } = useAuth()
  const history = useHistory()
  const [error, setError] = useState(null)
  const [isPrivate, setIsPrivate] = useState(false)

  const onSubmit = async data => {
    const { accountName, locationName, ...contact } = data
    const _locationName = isPrivate ? '自宅' : locationName
    return createAccount(accountName, _locationName, contact, isPrivate)
      .then(account => history.push(`/accounts/${account.id}`))
      .catch(error => {
        console.log(error)
        setError(error)
      })
  }

  if (!user || !user.displayName) {
    return <Redirect to="/" />
  }

  return (
    <Panel centered>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ px: 3 }}>
          <Typography align="center" sx={{ mb: 3 }} variant="h2">
            アカウント登録
          </Typography>
          <Box sx={{ mb: 2 }}>
            <Typography sx={{ mb: 1 }} variant="body2">
              利用形態
            </Typography>
            <RadioGroup value={isPrivate} onChange={e => setIsPrivate(JSON.parse(e.target.value))}>
              <FormControlLabel
                value={false}
                control={<Radio color="primary" />}
                label="会社で利用"
              />
              <FormControlLabel
                value={true}
                control={<Radio color="primary" />}
                label="個人で利用"
              />
            </RadioGroup>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography sx={{ mb: 1 }} variant="body2">
              アカウント情報
            </Typography>
            <Controller
              name="accountName"
              control={control}
              rules={{ required: true, maxLength: 20 }}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  sx={{ mb: 2 }}
                  label="アカウント名"
                  placeholder="三和商事株式会社"
                  disabled={isSubmitting}
                  helperText={errors.accountName && '20 文字以内で入力してください'}
                />
              )}
            />
          </Box>
          {!isPrivate && (
            <div>
              <Typography sx={{ mb: 1 }} variant="body2">
                連絡先情報
              </Typography>
              <Controller
                name="locationName"
                control={control}
                rules={{ required: true, maxLength: 20 }}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    sx={{ mb: 2 }}
                    label="拠点名"
                    placeholder="本社"
                    disabled={isSubmitting}
                    helperText={errors.locationName && '20 文字以内で入力してください'}
                  />
                )}
              />
              <ContactInput control={control} disabled={isSubmitting} errors={errors} required />
            </div>
          )}
          <Button
            variant="contained"
            fullWidth
            color="primary"
            size="large"
            style={{ height: 50 }}
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : '登録'}
          </Button>
          {Boolean(error) && (
            <ErrorDialog
              error="エラーが発生しました。大変お手数ですがしばらくしてから再度お試しください"
              onClose={() => setError(null)}
            />
          )}
        </Box>
      </form>
    </Panel>
  )
}
